import React, { useContext, useEffect, useState } from "react";
import Headers from "../../Common/Headers";
import "./style.css";
import Switch from "@mui/material/Switch";
import Dropzone from "../../Common/DropZone/DropZone";
import Post from "../../../../Apis/backlink/Post";
import Get from "../../../../Apis/backlink/Get";
import { getAPIUrlBM } from "../../../../utils/config";
import Papa from "papaparse";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import favicon from "../../Assets/Favicon.png";
import LimitsContext from "../../../../contextApi/backlink/LimitsContext";
import { PlanInfo } from "../../../utils/backLinkPlanInfo";
import { auth2 } from "../../../../firebase";
import loadingGif from "../../Assets/loading.gif";
import RouteChecker from "../../../utils/RouteChecker";
import TipLoader from "../../../utils/TipLoader/TipLoader";

function AddLinks() {
  const { setBackLinkLimits, totalBackLinks, getDomainCount } =
    useContext(LimitsContext);
  const [planType, setPlanType] = useState("plan1");
  const [isloading, setIsloading] = useState(true);
  const [tipLoader, setTipLoader] = useState(false);
  const [onCompleteLoad, setOnCompleteLoad] = useState(null);
  const [isCSV, setIsCSV] = useState(true);

  const [csvFile, setCsvFile] = useState();
  const [csvData, setCsvData] = useState();
  const [linkData, setLinkData] = useState([{}, {}, {}, {}, {}]);
  const params = useParams();
  const [listId, setListId] = useState(
    params.listId !== undefined ? params.listId : "",
  );
  console.log({ linkData, csvData });
  const [lists, setLists] = useState();
  const [csvError, setCsvError] = useState("");
  const [linkError, setLinkError] = useState("");
  const navigate = useNavigate();
  const sweet = window.sweet;

  const header = {
    heading: "Add Links",
    link: "http://links.backlinkchecker.info/add-links-tutorial",
    isSubHeading: false,
  };

  const handleChange = (event) => {
    setIsCSV(event.target.checked);
  };

  // useEffect for CSV File upload
  useEffect(() => {
    setCsvError("");
    if (csvFile)
      Papa.parse(csvFile, {
        complete: function (results) {
          // return false;

          var tempArr = [];
          results.data.map((arr, ind) => {
            // console.log(arr, "Ankur is coming here");
            if ((arr[0] === "" || !arr[0]) && (arr[1] === "" || !arr[1])) {
              return null;
            }
            if (
              arr[0] === "link_from" ||
              arr[0] === "link_to" ||
              arr[0] === ""
            ) {
              return null;
            }
            if (
              arr[1] === "link_from" ||
              arr[1] === "link_to" ||
              arr[1] === ""
            ) {
              return 0;
            }
            var tempObj = {
              linkFrom: arr[0]?.trim(),
              linkTo: arr[1]?.trim(),
              relTag: arr[2]?.trim() === undefined ? "" : arr[2]?.trim(),
              anchor: arr[3]?.trim() === undefined ? "" : arr[3]?.trim(),
              notes: arr[4] !== "NULL" ? arr[4] : "",
            };
            tempArr.push(tempObj);
          });
          console.log(tempArr, "CSV HAS BEEN PARSED");
          setCsvData(tempArr);
          validateCSV(tempArr);
        },
      });
  }, [csvFile]);

  const skipHttp = (link) => {
    // if (link.substr(0, 8) === "https://") return link.substr(8);
    // else if (link.substr(0, 7) === "http://") return link.substr(7);
    // console.log(link, "Ankur is coming here");
    link = link.replace("http://", "");
    if (link.includes("https://")) return link;
    else return "https://" + link;
  };

  const removeHttp = (parseData) => {
    for (var i = 0; i < parseData.length; i++) {
      // console.log(i, "Ankur is coming here");
      parseData[i].linkFrom = skipHttp(parseData[i].linkFrom);
      parseData[i].linkTo = skipHttp(parseData[i].linkTo);
    }
    return parseData;
  };

  const validateLink = (link, setLinkError) => {
    if (link.length === 0) {
      if (setLinkError) setLinkError("Link cannot be empty!");
      else setCsvError(`Invalid Link "${link}", Reason: Link cannot be empty!`);
      return false;
    } else if (link.length > 1000) {
      if (setLinkError) {
        setLinkError(
          `Invalid Link "${link}", Reason: Link Length should be less than 1000 characters`,
        );
      } else
        setCsvError(
          `Invalid Link "${link}", Reason: Link Length should be less than 1000 characters`,
        );
      return false;
    } else if (link.includes(" ")) {
      if (setLinkError)
        setLinkError(
          `Invalid Link "${link}", Reason: Link cannot contain space or special characters`,
        );
      else
        setCsvError(
          `Invalid Link "${link}", Reason: Link cannot contain space or special characters`,
        );

      return false;
    }
    // const pattern = /[\u2070-\u209F]|[\u0027\u0022]/g;
    // const pattern = new RegExp(
    //   "^(https?:\\/\\/)?" + // protocol
    //     "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    //     "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    //     "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    //     "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    //     "(\\#[-a-z\\d_]*)?$",
    //   "i",
    // );
    // console.log("pattern does", pattern.test(link));

    // if (pattern.test(link.toString())) {
    //   if (setLinkError)
    //     setLinkError(
    //       `Invalid Link "${link}", Reason: Link cannot contain space or special characters`,
    //     );
    //   else
    //     setCsvError(
    //       `Invalid Link "${link}", Reason: Link cannot contain space or special characters`,
    //     );
    //   return false;
    // }
    return true;
    // if (link.substr)
    //   var pattern = new RegExp(
    //     "^(https?:\\/\\/)?" + // protocol
    //       "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    //       "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    //       "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    //       "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    //       "(\\#[-a-z\\d_]*)?$",
    //     "i",
    //   ); // fragment locator
    // return !!pattern.test(link);
  };

  const validateNotes = (notes) => {
    // const pattern = /[\u0027\u0022]/g;

    // if (notes && notes.length && pattern.test(notes.toString())) {
    //   setCsvError(
    //     `Invalid Notes "${notes}", Reason: Notes cannot contain special characters`,
    //   );
    //   return false;
    // }
    return true;
  };
  const validateAnchor = (anchor) => {
    if (anchor === "" || anchor === undefined) return true;
    if (anchor.length > 1000) {
      setCsvError(
        `Invalid Anchor "${anchor}", Reason: Anchor Length should be less than 1000 characters`,
      );
      return false;
    }
    // const pattern = /[\u0027\u0022]/g;

    // if (anchor && anchor.length && pattern.test(anchor.toString())) {
    //   setCsvError(
    //     `Invalid Anchor "${anchor}", Reason: Anchor cannot contain special characters`,
    //   );
    //   return false;
    // }
    return true;
  };

  const validateCSV = (csvData) => {
    // console.log(csvData, "Ankur is coming here");
    var isValid = true;
    csvData?.every((links) => {
      if (
        !(
          (links?.linkFrom === "" || links?.linkFrom === undefined) &&
          (links?.linkTo === "" || links?.linkTo === undefined)
        )
      ) {
        for (var link in links) {
          var field = link;
          var val = links[link];
          // console.log(field, val, "Ankur is coming here");
          if (field === "linkFrom" || field === "linkTo") {
            if (!validateLink(val)) {
              isValid = false;
              break;
            }
          }
          // console.log(field, val, "Field and val");
          if (field === "relTag") {
            // console.log(val, "Ankur is coming here");
            if (val !== "" && val !== "dofollow" && val !== "nofollow" && val) {
              setCsvError(
                `Invalid relTag "${val}", Reason: The relTag can be dofollow and nofollow only.`,
              );
              isValid = false;
              break;
            }
          }
          if (field === "anchor") {
            // console.log(val, validateNotes(val), "Validating Acnhor");
            if (!validateAnchor(val)) {
              isValid = false;
              break;
            }
          }
          if (field === "notes") {
            if (!validateNotes(val)) {
              isValid = false;
              break;
            }
          }
        }

        if (!isValid) {
          return false;
        }
        return true;
      }
    });

    return isValid;
  };

  const validateLinkManual = (id, val) => {
    if (!validateLink(val, setLinkError)) {
      document.getElementById(id).style.border = "1px solid red";
    } else {
      document.getElementById(id).style.border = "1px solid #4f4f4f";
    }
  };

  const validateAnchorManual = (id, val) => {
    if (!validateAnchor(val)) {
      document.getElementById(id).style.border = "1px solid red";
    } else {
      document.getElementById(id).style.border = "1px solid #4f4f4f";
    }
  };

  // validationManual Links
  const validateManual = (item, index) => {
    if (!item.linkFrom && !item.linkTo) {
      ["linkfrom", "linkto"].forEach((field) => {
        document.getElementById(`ID_${index}_${field}`).style.border =
          "1px solid #4f4f4f";
      });

      return false;
    }
    var validItem = true;
    if (!item.linkFrom) {
      document.getElementById("ID_" + index + "_linkfrom").style.border =
        "1px solid red";
      validItem = false;
    } else if (!validateLink(item?.linkFrom)) {
      document.getElementById("ID_" + index + "_linkfrom").style.border =
        "1px solid red";
      validItem = false;
    }
    if (!item.linkTo) {
      document.getElementById("ID_" + index + "_linkto").style.border =
        "1px solid red";
      validItem = false;
    } else if (!validateLink(item?.linkTo)) {
      document.getElementById("ID_" + index + "_linkto").style.border =
        "1px solid red";
      validItem = false;
    }
    // if (!item.anchor) {
    //   document.getElementById("ID_" + index + "_anchor").style.border =
    //     "1px solid red";
    //   validItem = false;
    // } else if (!validateAnchor(item?.anchor)) {
    //   document.getElementById("ID_" + index + "_anchor").style.border =
    //     "1px solid red";
    //   validItem = false;
    // }
    return validItem;
  };

  // function to remove duplicate links
  const removeAndCountDuplicates = async (array) => {
    try {
      let duplicateCount = 0;
      const uniqueArray = [];
      let hashMap = {};

      // function to generate a unique key for each link
      const generateKey = (linkFrom, linkTo, relTag, anchor) => {
        let key = linkFrom + linkTo;
        if (relTag) key += relTag;
        if (anchor) key += anchor;
        return key;
      };
      // fectch all the links associated with the current selected list
      const url = getAPIUrlBM();
      const res = await Get(url + `/getLinks/${listId}`);
      const links = res.response;
      // create a hashmap of all the links
      for (const link of links) {
        const key = generateKey(
          link.link_from,
          link.link_to,
          link.rel_tag,
          link.anchor,
        );
        hashMap[key] = true;
      }

      // check if the link is already present in the hashmap
      for (const item of array) {
        const key = generateKey(
          item.linkFrom,
          item.linkTo,
          item.relTag,
          item.anchor,
        );
        if (hashMap[key]) {
          duplicateCount++;
        } else {
          hashMap[key] = true;
          uniqueArray.push(item);
        }
      }
      return { uniqueArray, duplicateCount };
    } catch (error) {
      console.log(error);
    }
  };

  // submit Hanlder for add links
  const submitHandler = async () => {
    try {
      if (listId === "" || listId === "none") {
        sweet({
          title: "Alert!",
          text: `Please select a list from the drop down.`,
          icon: "info",
        });
        return;
      }
      if (isCSV && csvData === undefined) {
        sweet({
          title: "Alert!",
          text: `Please Upload a CSV File.`,
          icon: "info",
        });
        return;
      }
      var validData = true;
      let count = 0;
      var parseData = isCSV
        ? csvData?.filter((item, index) => {
            // if (!item.linkFrom || !item.linkTo) {
            //   return false;
            // }
            item.linkId = new Date().getTime() + index;
            return item;
          })
        : linkData?.filter((item, index) => {
            if (
              item.linkFrom ||
              item.linkTo ||
              item.anchor ||
              item.notes ||
              item.relTag
            )
              count += 1;
            if (!validateManual(item, index)) {
              return false;
            }

            item.linkId = new Date().getTime() + index;
            return item;
          });

      console.log(parseData, count, "Ankur is coming here");
      if (parseData?.length < count) {
        sweet({
          title: "Alert!",
          text: `Please fill all red fields properly.`,
          icon: "info",
        });
        return;
      }

      if (!parseData.length) {
        sweet({
          title: "Alert!",
          text: `Please make atleast one complete entry.`,
          icon: "info",
        });
        return;
      }

      if (
        parseData?.length + parseInt(totalBackLinks) >
        (PlanInfo[`${planType}`]?.totalBackLinks || 0)
      ) {
        sweet({
          title: "INFO!",
          text: `File contains more links than your link limits.`,
          icon: "error",
        });
        return;
      }

      setTipLoader(true);
      // removing http and https from the links
      parseData = removeHttp(parseData);
      console.log({ parseData });
      const { uniqueArray, duplicateCount } = await removeAndCountDuplicates(
        parseData,
      );
      parseData = uniqueArray;
      // if (!validData) {
      //   infoSweetAlert();
      //   return;
      // }
      // const compare = isCSV ? csvData?.length : linkData.length;

      const fun = async () => {
        try {
          if (!parseData.length) {
            sweet({
              title: "Alert!",
              text: `Please make atleast one unique complete entry.`,
              icon: "info",
            });
            return;
          }
          const URL = getAPIUrlBM();
          const response = await Post(URL + "/createlink", {
            data: parseData,
            listId: listId,
          });
          getDomainCount();
          setOnCompleteLoad(() => () => {
            if (response.status === "limit") {
              sweet({
                title: "Max domain count reached.",
                text: `You have added ${response.count} out of ${response.limit} domains as per your current plan.`,
                icon: "error",
              });
              return true;
            }
            if (response.message === "Upgrade Plan for more links.") {
              sweet({
                title: "INFO!",
                text: `${response.message}`,
                icon: "error",
              });
              navigate(`/backlink/upgrade`);

              setLinkData([{}, {}, {}, {}, {}]);
              return true;
            }
            console.log({ response });
            if (response.message === "Link created successfully") {
              // const linksAdded = response.response.length;
              sweet({
                title: "Success!",
                text: `Congo!!! ${parseData.length} links are added successfully`,
                icon: "success",
              }).then(() => {
                navigate(`/backlink/link/${listId}`);
              });
              setBackLinkLimits(response.backLinkLimits);
              setLinkData([{}, {}, {}, {}, {}]);
              return true;
            }
          });
        } catch (error) {
          console.log(error);
        }
      };

      if (duplicateCount > 0) {
        setTipLoader(false);
        if (!parseData.length) {
          sweet({
            title: "Alert!",
            text: `${duplicateCount} duplicate links found, Please make atleast one complete unique entry.`,
            icon: "info",
          });
          return;
        }
        sweet({
          title: "Duplicate Links!",
          text: `${duplicateCount} duplicate links found and removed.\n\n${parseData.length} unique links will be added.\n\nDo you want to continue?`,
          icon: "info",
          buttons: {
            cancel: true,
            confirm: true,
          },
        }).then((value) => {
          if (value) {
            setTipLoader(true);
            fun();
          }
        });
      } else {
        fun();
      }
    } catch (error) {
      setTipLoader(false);
      console.log(error);
    }
  };

  const getLists = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Get(url + "/getlistname");
      setLists(res.response);
      setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getPlan = async () => {
    try {
      let paid;
      if (localStorage.getItem("workspaceId")) {
        const url = getAPIUrlBM();
        const res = await Get(url + "/getuserbyuid");

        if (res.data.custom) {
          paid = res.data.custom;
        }
      } else {
        paid = auth2.currentUser.reloadUserInfo?.customAttributes;
      }

      if (paid !== undefined && typeof paid === "string") {
        paid = JSON.parse(paid);
      } else if (!paid) {
        paid = { plan: "plan1" };
      }
      setPlanType(paid.plan);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPlan();
    getLists();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Helmet>
        <title>AddLinks - Backlink Checker</title>
        <meta
          name="description"
          content="You can define List Name, list subscribers & frequency and isPublic at list level"
        />
        {/* <meta property="og:url" content="https://app.linkly.digital/lists" /> */}
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta property="og:title" content="AddLinks - Backlink Checker" />
        <meta
          property="og:description"
          content="You can define List Name, list subscribers & frequency and isPublic at list level"
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
      </Helmet>
      <RouteChecker url="linkAddScreen">
        {!isloading ? (
          <>
            {tipLoader && (
              <TipLoader
                setTipLoader={setTipLoader}
                onCompleteLoad={onCompleteLoad}
              />
            )}
            <Headers header={header} />

            <div className="selectSection">
              <div>
                <p className="subHeading">Select a List</p>
                <div className="selectList subHeadingItems">
                  <span>
                    <select
                      name="curList"
                      value={listId}
                      onChange={(e) => setListId(e.target.value)}
                    >
                      <option value="none">Select a List</option>
                      {lists?.map((list, index) => (
                        <option value={list.list_id} key={index}>
                          {list.list_name}
                        </option>
                      ))}
                    </select>
                    &nbsp; &nbsp; &nbsp;
                  </span>
                  <span> or &nbsp;</span>
                  <span>
                    <button
                      className="addNewListButton"
                      onClick={() => navigate("/backlink/list/add")}
                    >
                      Add new List
                    </button>
                    &nbsp;
                  </span>
                </div>
              </div>

              <div>
                <p className="subHeading">Select Input Method</p>
                <div className="subHeadingItems">
                  <span>Fill Manually &nbsp;</span>
                  <span>
                    <Switch
                      checked={isCSV}
                      onChange={handleChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />{" "}
                    &nbsp;
                  </span>
                  <span>Import from CSV &nbsp;</span>
                  <a
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    href="https://docs.google.com/spreadsheets/d/1t_lECgjavjBODxj3WsaWOymmaHe12KvPePzyfAQmMDw/edit#gid=0"
                  >
                    Download Sample CSV
                  </a>
                </div>
              </div>
            </div>

            <div>
              {isCSV ? (
                <div className="csvContainer">
                  <Dropzone setCsvFile={setCsvFile} />
                  {csvError.length !== 0 && (
                    <p className="errorInput">{csvError}</p>
                  )}
                  <p style={{ maxWidth: "35vw", padding: "0 12px" }}>
                    You can also
                    <Link to="/backlink/fetch-backlinks">
                      <span style={{ color: "#0d6efd" }}>
                        &nbsp;discover new backlinks&nbsp;
                      </span>
                    </Link>
                    & add them for monitoring. This is given as an add-on to
                    reduce your time required. Discover backlinks is not our
                    main functionality
                  </p>
                  <button
                    className={
                      csvError.length !== 0
                        ? "deactivatedButton"
                        : "uploadButton"
                    }
                    onClick={() => submitHandler()}
                    disabled={csvError.length !== 0 ? true : false}
                  >
                    Upload CSV & Add Links
                  </button>
                </div>
              ) : (
                <div>
                  <div className="manualContainer">
                    <div className="manualItem">
                      <div>
                        <p className="subHeading">Link from</p>
                        <p className="subHeadingItems">
                          Page from which you are getting a backlink.
                        </p>
                      </div>
                      <div className="inputSection">
                        {linkData.map((item, i) => {
                          return (
                            <input
                              name="linkFrom"
                              key={i + "linkfrom"}
                              id={"ID_" + i + "_linkfrom"}
                              type="text"
                              defaultValue={linkData[i].linkFrom}
                              onChange={(e) => {
                                setLinkData((link) => {
                                  const arr = link;
                                  arr[i].linkFrom = e.target.value;
                                  validateLinkManual(
                                    "ID_" + i + "_linkfrom",
                                    e.target.value,
                                  );
                                  return arr;
                                });
                              }}
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="manualItem">
                      <div>
                        <p className="subHeading">Link to</p>
                        <p className="subHeadingItems">
                          Link which will be in href tag. <br />
                          Please make sure you can see this link in view-source.
                        </p>
                      </div>
                      <div className="inputSection">
                        {linkData.map((item, i) => {
                          return (
                            <input
                              name="linkTo"
                              id={"ID_" + i + "_linkto"}
                              key={i + "linkTo"}
                              type="text"
                              // value={linkData[i].linkTo}
                              defaultValue={linkData[i].linkTo}
                              onChange={(e) =>
                                setLinkData((link) => {
                                  const arr = link;
                                  validateLinkManual(
                                    "ID_" + i + "_linkto",
                                    e.target.value,
                                  );
                                  arr[i].linkTo = e.target.value;
                                  return arr;
                                })
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="manualItem">
                      <div>
                        <p className="subHeading">Rel tag (optional)</p>
                        <p className="subHeadingItems">
                          nofollow or dofollow ?
                        </p>
                      </div>
                      <div className="inputSection">
                        {linkData.map((item, i) => (
                          <select
                            name="relTag"
                            key={i + "rel"}
                            id={"ID_" + i + "_relTag"}
                            value={linkData[i].relTag}
                            className="relTagSelect"
                            onChange={(e) => {
                              setLinkData((link) => {
                                const arr = link;
                                arr[i].relTag = e.target.value;
                                return arr;
                              });
                            }}
                          >
                            <option value="relTag">Select Rel Tag </option>
                            <option value="nofollow">No Follow</option>
                            <option value="dofollow">Do Follow</option>
                          </select>
                        ))}
                      </div>
                    </div>
                    <div className="manualItem">
                      <div>
                        <p className="subHeading">Notes (optional)</p>
                        <p className="subHeadingItems">Enter the notes</p>
                      </div>
                      <div className="inputSection">
                        {linkData.map((item, i) => {
                          return (
                            <input
                              name="notes"
                              id={"ID_" + i + "_notes"}
                              key={i + "notes"}
                              type="text"
                              value={linkData[i].notes}
                              placeholder="Enter the notes here"
                              onChange={(e) =>
                                setLinkData((link) => {
                                  const arr = link;
                                  arr[i].notes = e.target.value;
                                  return arr;
                                })
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="manualItem">
                      <div>
                        <p className="subHeading">Anchor (optional)</p>
                        <p className="subHeadingItems">
                          Anchor that is present in the 'a' tag of that link
                        </p>
                      </div>
                      <div
                        className="inputSection"
                        style={{
                          position: "relative",
                          width: "100%",
                        }}
                      >
                        {linkData.map((item, i) => {
                          return (
                            <div
                              className="anchorFeild"
                              style={{
                                position: "relative",
                                width: "100%",
                              }}
                            >
                              <input
                                name="anchor"
                                id={"ID_" + i + "_anchor"}
                                type="text"
                                key={i + "anchor"}
                                value={linkData[i].anchor}
                                onChange={(e) =>
                                  setLinkData((link) => {
                                    const arr = link;
                                    validateAnchorManual(
                                      "ID_" + i + "_anchor",
                                      e.target.value,
                                    );
                                    arr[i].anchor = e.target.value;
                                    return arr;
                                  })
                                }
                              />
                              {i == linkData.length - 1 && (
                                <button
                                  className="plusButton"
                                  onClick={() => setLinkData([...linkData, {}])}
                                >
                                  +
                                </button>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  <p className="noteText">
                    You can also
                    <Link to="/backlink/fetch-backlinks">
                      <span style={{ color: "#0d6efd" }}>
                        &nbsp;discover new backlinks&nbsp;
                      </span>
                    </Link>
                    & add them for monitoring. This is given as an add-on to
                    reduce your time required. Discover backlinks is not our
                    main functionality
                  </p>
                  <div className="centerButton">
                    <button
                      className="uploadButton"
                      onClick={() => submitHandler()}
                    >
                      {"Add Links"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "89vh",
              margin: "-15px -30px",
            }}
          >
            <img
              style={{
                width: "82vw",
                height: "94vh",
              }}
              alt=""
              src={loadingGif}
            />
          </div>
        )}
      </RouteChecker>
    </div>
  );
}

export default AddLinks;
